import {RevisionService} from "@/services/RevisionService";
import {QuestionnaireService} from "@/services/QuestionnaireService";

const state = {
  revisions: [],
  currentRevision: null
};

const mutations = {
  SET_REVISIONS(state, payload) {
    state.revisions = payload;
  },
  ADD_REVISION(state, payload) {
    state.revisions.push(payload);
  },
  SET_CURRENT_REVISION(state, payload) {
    state.currentRevision = payload;
  },
  UPDATE_REVISION(state, updated) {
    const index = state.revisions.findIndex(q => q.id === updated.id);
    if (index !== -1) state.revisions.splice(index, 1, updated);
  },
};

const actions = {
  async fetchNonConformityByRevisionId({ commit }) {
    const res = await RevisionService.getAllNonConformity();
    commit('SET_REVISIONS', res.data);
  },

  async fetchRevisions({ commit }) {
    const res = await RevisionService.getAll();
    commit('SET_REVISIONS', res.data);
  },

  async fetchRevisionById({ commit }, id) {
    const res = await RevisionService.show(id);
    commit('SET_CURRENT_REVISION', res.data);
    return res;
  },

  async createRevision({ commit }, revisionData) {
    const res = await RevisionService.create(revisionData);
    commit('ADD_REVISION', res.data);
    return res;
  },

  async updateRevision({ commit }, { id, data }) {
    const res = await RevisionService.update(id, data);
    commit('UPDATE_REVISION', res.data);
    return res;
  },

  async deleteRevision({ commit }, id) {
    await RevisionService.delete(id);
    commit('DELETE_REVISION', id);
  }
};

const getters = {
  revisions: state => state.revisions,
  currentRevision: state => state.currentRevision
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
